module.exports = __webpack_public_path__ + "img/Use.c8de5183.svg";